import React, { useRef, useEffect, useState, forwardRef } from "react";
import { createPortal } from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { getCokkie } from "../../../login/Login";
import { EventSourcePolyfill } from "event-source-polyfill";
import webrtcLoad from "./video";
import { Button } from "reactstrap";
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faEye, faEyeSlash, faRecordVinyl } from "@fortawesome/free-solid-svg-icons";
import { StyledTooltip } from "../../label/annotation/EditorView/EditorTopNavigationBar/EditorTopNavigationBar";

const VideoStreaming = forwardRef(
  ({ streamurl, style, title, eval_id, evalStatus, handleStartStop, setSelectedTab, samUrl }, ref) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [data, setData] = useState([]);
    const [status, setStatus] = useState("Disconnected");

    const [recording, setRecording] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [recordedChunks, setRecordedChunks] = useState([]);
    const [mediaList, setMediaList] = useState([]); // store snapshots + recordings
    const recordingCanvasRef = useRef(null);
    const [showMediaModal, setShowMediaModal] = useState(false);
    const [detailed_view, setDetailedView] = useState(false);
    const [availableLabels, setAvailableLabels] = useState([]); // from backend
    const [activeLabels, setActiveLabels] = useState([]); // currently visible/selected labels
    const [allHidden, setAllHidden] = useState(false); // hide/unhide toggle


    useEffect(() => {
      const url = String(streamurl || "").trim();
      if (!url || !videoRef.current) {
        setStatus("Disconnected");
        return undefined;
      }

      setStatus("Connecting");

      try {
        let mounted = true;
        const stopStream = webrtcLoad(url, {
          videoElement: videoRef.current,
          onStatusChange: (nextStatus) => {
            if (mounted) setStatus(nextStatus);
          },
        });

        return () => {
          mounted = false;
          stopStream?.();
        };
      } catch (error) {
        console.error("Unable to start WebRTC stream", error);
        setStatus("Connection failed");
        return undefined;
      }
    }, [streamurl, detailed_view]);

    // useEffect(() => {
    //   if (eval_id) {
    //     let cokkie = getCokkie("jwtToken");
    //     const endpoint = `${window["ENV"].API_URL}/${samUrl}`;

    //     const eventSource = new EventSourcePolyfill(endpoint, {
    //       headers: {
    //         Authorization: `Bearer ${cokkie}`,
    //       },
    //     });

    //     eventSource.onopen = () => {
    //       console.log("SSE Connection Established");
    //       setStatus("Connected");
    //     };

    //     eventSource.onmessage = (event) => {
    //       try {
    //         const parsed = JSON.parse(event.data);

    //         // Each event has one key like "frame_0001.jpg"
    //         Object.keys(parsed).forEach((key) => {
    //           const frame = parsed[key];
    //           let boxes = [];

    //           if (Array.isArray(frame.annotation) && frame.annotation.length > 0) {
    //             boxes = frame.annotation[0].map((ann, idx) => ({
    //               x: ann[0],
    //               y: ann[1],
    //               w: ann[2],
    //               h: ann[3],
    //               label: `${ann[4]} (${(frame.score?.[idx] ?? 0).toFixed(2)})`,
    //               color: ann[5] || "lime",
    //             }));
    //           }

    //           setData(boxes);
    // if (Array.isArray(frame.labels)) {
    //   setAvailableLabels((prevLabels) => {
    //     const incoming = frame.labels;

    //     // Merge incoming labels with existing, preserving user-selected colors
    //     const merged = incoming.map((inc) => {
    //       const existing = prevLabels.find((p) => p.name === inc.name);
    //       return existing
    //         ? { ...inc, colour: existing.colour } // keep local color
    //         : inc; // new label
    //     });

    //     // Add any labels that were removed in stream but we still had locally (optional)
    //     const allUnique = [
    //       ...merged,
    //       ...prevLabels.filter((p) => !incoming.some((inc) => inc.name === p.name)),
    //     ];

    //     return allUnique;
    //   });

    //   // Initialize active labels only once (first time)
    //   setActiveLabels((prev) =>
    //     prev.length === 0 ? frame.labels.map((l) => l.name) : prev
    //   );
    // }
    //         });
    //       } catch (err) {
    //         console.error("Invalid SSE data:", event.data, err);
    //       }
    //     };

    //     eventSource.onerror = (error) => {
    //       console.error("SSE error:", error);
    //       setStatus("Disconnected (Error)");
    //       eventSource.close();
    //     };

    //     return () => {
    //       console.log("Closing SSE connection");
    //       eventSource.close();
    //     };
    //   }
    // }, [samUrl]);

    function drawPredictions(ctx, predictions) {
      if (!Array.isArray(predictions) || predictions.length === 0) return;
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      const canvasW = ctx.canvas.width;
      const canvasH = ctx.canvas.height;

      predictions.forEach((pred) => {
        if (allHidden) return; // hide all
        if (activeLabels.length > 0 && !activeLabels.includes(pred.label.split(" ")[0])) return; // filter by active label

        const { x, y, w, h, label, color } = pred;

        // Scale coords to canvas size
        const scaleX = canvasW / 1728;
        const scaleY = canvasH / 1080;

        const sx = Math.round(x * scaleX);
        const sy = Math.round(y * scaleY);
        const sw = Math.round(w * scaleX);
        const sh = Math.round(h * scaleY);

        // Stroke + fill style
        const strokeFill = color ?? "#ff3838";
        ctx.globalAlpha = 1;
        ctx.lineWidth = Math.max(2, Math.round(canvasW * 0.004));
        ctx.strokeStyle = strokeFill;
        ctx.fillStyle = strokeFill;

        // Draw bounding box
        if (sw > 1 && sh > 1) ctx.strokeRect(sx, sy, sw, sh);

        // Semi-transparent fill
        ctx.globalAlpha = 0.35;
        ctx.fillRect(sx, sy, sw, sh);

        ctx.globalAlpha = 1;

        // ==== Label Background + Text ====
        if (label && label.trim() !== "") {
          const smallFontSize = (canvasW * 0.012) | 0; // reduced font size
          ctx.font = "bold " + smallFontSize + "px Montserrat, sans-serif";

          const metrics = ctx.measureText(label);
          const textWidth = metrics.width;
          const paddingX = 4; // smaller padding
          const paddingY = 2;
          const rectHeight = smallFontSize + paddingY * 2;
          const rectWidth = textWidth + paddingX * 2;

          let rectX = sx;
          let rectY;
          if (sy - rectHeight <= 0) {
            rectY = sy;
          } else {
            rectY = sy - rectHeight;
          }

          ctx.fillStyle = strokeFill;
          ctx.fillRect(rectX, rectY, rectWidth, rectHeight);

          ctx.fillStyle = "#fff";
          ctx.textBaseline = "middle";
          ctx.textAlign = "left";
          ctx.fillText(label, Math.round(rectX + paddingX), Math.round(rectY + rectHeight / 2));
        }
      });
    }


    function setupCanvas(canvas) {
      const dpr = window.devicePixelRatio || 1;
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      const ctx = canvas.getContext("2d");
      ctx.scale(dpr, dpr);
      return ctx;
    }

    useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas ? setupCanvas(canvas) : null;
      let animationId;

      const render = () => {
        if (ctx && data.length > 0) {
          drawPredictions(ctx, data);
        } else if (ctx) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
        animationId = requestAnimationFrame(render);
      };

      render();

      return () => cancelAnimationFrame(animationId);
    }, [data]);



    const startRecording = () => {
      const video = videoRef.current;
      const overlay = canvasRef.current;

      if (!video || !overlay) return;

      // Wait until video metadata is loaded
      if (video.videoWidth === 0 || video.videoHeight === 0) {
        video.onloadedmetadata = () => startRecording();
        return;
      }

      const recordingCanvas = document.createElement("canvas");
      recordingCanvas.width = video.videoWidth;
      recordingCanvas.height = video.videoHeight;
      recordingCanvasRef.current = recordingCanvas;

      const ctx = recordingCanvas.getContext("2d");

      const fps = 30;
      let drawing = true; // control drawing loop

      const drawLoop = () => {
        if (!drawing) return;
        ctx.clearRect(0, 0, recordingCanvas.width, recordingCanvas.height);
        ctx.drawImage(video, 0, 0, recordingCanvas.width, recordingCanvas.height);
        ctx.drawImage(overlay, 0, 0, recordingCanvas.width, recordingCanvas.height);
        requestAnimationFrame(drawLoop);
      };

      drawLoop();

      const stream = recordingCanvas.captureStream(fps);
      const recorder = new MediaRecorder(stream, { mimeType: "video/webm" });
      let chunks = [];

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunks.push(e.data);
      };

      recorder.onstop = () => {
        drawing = false; // stop draw loop
        const blob = new Blob(chunks, { type: "video/webm" });
        const url = URL.createObjectURL(blob);
        setMediaList((prev) => [...prev, { type: "video", url, blob }]);
        setRecordedChunks([]);
      };

      recorder.start();
      setMediaRecorder(recorder);
      setRecording(true);
    };

    const stopRecording = () => {
      if (mediaRecorder) {
        mediaRecorder.stop();
        setRecording(false);
      }
    };

    const takeSnapshot = () => {
      const video = videoRef.current;
      const overlay = canvasRef.current;

      if (!video || !overlay) return;

      const snapshotCanvas = document.createElement("canvas");
      snapshotCanvas.width = video.videoWidth;
      snapshotCanvas.height = video.videoHeight;

      const ctx = snapshotCanvas.getContext("2d");
      ctx.drawImage(video, 0, 0, snapshotCanvas.width, snapshotCanvas.height);
      ctx.drawImage(overlay, 0, 0, snapshotCanvas.width, snapshotCanvas.height);

      snapshotCanvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        setMediaList((prev) => [...prev, { type: "image", url, blob }]);
      }, "image/png");
    };

    // useEffect(() => {
    //   // Start recording automatically once stream is loaded
    //   if (data) {
    //     startRecording();
    //   }
    // }, [status]);

    const handleToggleRecording = () => {
      if (recording) {
        stopRecording();
      } else {
        startRecording();
      }
    };


    const s3 = new S3Client({
      region: "your-region",
      credentials: {
        accessKeyId: "YOUR_ACCESS_KEY",
        secretAccessKey: "YOUR_SECRET_KEY",
        sessionToken: "YOUR_SESSION_TOKEN", // if using temporary creds
      },
    });

    const uploadToS3 = async (file, filename) => {
      try {
        const params = {
          Bucket: "your-bucket-name",
          Key: filename,
          Body: file,
          ContentType: file.type,
        };
        await s3.send(new PutObjectCommand(params));
        alert(`Uploaded: ${filename}`);
      } catch (err) {
        console.error("S3 Upload Error:", err);
      }
    };

    console.log(activeLabels);

    const streamView = (
        <div
          className={detailed_view ? "sample-bg" : ""}
          style={
            detailed_view
              ? {
                position: "fixed",
                inset: 0,
                width: "100vw",
                height: "100vh",
                padding: "20px",
                zIndex: 20000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxSizing: "border-box",
              }
              : {}
          }
          onClick={() => detailed_view && setDetailedView(false)}
        >
          <div
            className={detailed_view ? "modal-903 ReactModal__Content position-relative" : ""}
            onClick={(e) => e.stopPropagation()}
          >

            <>
              {detailed_view ? (
                <div className=" me-0 d-a justify-content-between w-100 px-4 py-2">
                  <h5 className={`mb-0 font-bold`}>{title}</h5>
                  <FontAwesomeIcon
                    className="button-icon"
                    icon={faClose}
                    onClick={() => setDetailedView(false)}
                  />

                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-between gap-2 mb-3 mt-2">
                  <h6 className="mb-0">{title}</h6>
                  <span
                    className={`badge ${status === "Connected" ? "bg-success" : status === "Connection failed" ? "bg-danger" : "bg-secondary"}`}
                  >
                    {status}
                  </span>
                </div>
              )}
              {detailed_view && (
                <div className="versionDetails4 d-flex align-items-center gap-2 mb-2 mt-2 overflow-auto py-2">
                  {/* Hide / Unhide buttons */}

                  <StyledTooltip
                    title={allHidden ? "show all" : "hide all"}
                  >
                    <FontAwesomeIcon
                      icon={allHidden ? faEyeSlash : faEye}
                      onClick={() => setAllHidden(!allHidden)}
                      className=" cursor-pointer button-icon button-icon-bg"
                      style={{ marginTop: "2px" }}
                    />
                  </StyledTooltip>

                  {/* Label chips */}
                  {availableLabels.map((lbl, index) => {
                    const isActive = activeLabels.includes(lbl.name);

                    return (
                      <div
                        key={lbl.name}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "4px 10px",
                          borderRadius: "20px",
                          cursor: "pointer",
                          border: `2px dotted #eee`,
                          opacity: isActive ? 1 : 0.5,
                          userSelect: "none",
                          width:"100%"
                         
                        }}
                        onClick={(e) => {
                          // avoid click when selecting color
                          if (e.target.type === "color") return;
                          setAllHidden(false);
                          setActiveLabels((prev) =>
                            prev.includes(lbl.name)
                              ? prev.filter((l) => l !== lbl.name)
                              : [...prev, lbl.name]
                          );
                        }}
                      >
                        {/* 🎨 Color Picker */}
                        <input
                          type="color"
                          value={lbl.colour}
                          onChange={(e) => {
                            const newColor = e.target.value;
                            setAvailableLabels((prev) =>
                              prev.map((l, i) =>
                                i === index ? { ...l, colour: newColor } : l
                              )
                            );

                            // Also update drawn box colors dynamically
                            setData((prev) =>
                              prev.map((box) =>
                                box.label.split(" ")[0] === lbl.name
                                  ? { ...box, color: newColor }
                                  : box
                              )
                            );
                          }}
                          style={{
                            appearance: "none",
                            border: "none",
                            // background: "none",
                            width: 16,
                            height: 16,
                            borderRadius: "50%",
                            cursor: "pointer",
                            backgroundColor: lbl.colour,
                            padding: 0,
                          }}
                          onClick={(e) => e.stopPropagation()} // prevent toggling when clicking the picker
                        />

                        {/* Label name */}
                        <span style={{ fontSize: "14px", color: "black",whiteSpace:"nowrap"}}>{lbl.name}</span>
                      </div>
                    );
                  })}
                </div>
              )}
              <div className="d-flex w-100" style={{ height: 'inherit' }}>
                <div
                  className={`d-j ${detailed_view && 'mt-0'}`}
                  style={{
                    width: detailed_view ? "" : "100%",
                    height: detailed_view && '75%',
                    margin: detailed_view ? "" : "initial",
                    flex: 'auto'
                  }}
                  onClick={() => !detailed_view && setDetailedView(true)}
                >
                  {/* Container holds video + canvas + controls */}
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <video
                      id="video"
                      ref={videoRef}
                      autoPlay
                      className="rounded-2"
                      style={{
                        objectFit: "contain",
                        maxHeight: "100%",
                        maxWidth: "100%",
                        width: !detailed_view ? "100%" : "100%",
                        display: "block"
                      }}
                    ></video>

                    {/* Canvas overlays video */}
                    <canvas
                      ref={canvasRef}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: !detailed_view ? "100%" : "100%",
                        height: "100%",
                        pointerEvents: "none",
                        zIndex: 1
                      }}
                    />

                    {detailed_view && (
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          left: "10px",
                          zIndex: 2
                        }}
                      >
                        <div className="d-a">
                          {/* {recording && */}
                          <button
                            type="button"
                            className="btn px-1"
                            onClick={stopRecording}
                          >
                            <b style={{ color: 'red' }}> {recording ? "Recording..." : " "}</b>
                          </button>
                          {/* } */}
                        </div>
                      </div>
                    )}


                    {detailed_view && (
                      <div
                        style={{
                          position: "absolute",
                          bottom: "10px",
                          right: "10px",
                          zIndex: 2
                        }}
                      >
                        <StyledTooltip title={'Snapshot'}>
                          <button
                            type="button"
                            className="btn px-1"
                            onClick={takeSnapshot}
                          >
                            <img
                              src="/ico/capture.png"
                              style={{ width: "32px", cursor: "pointer" }}
                              alt="Capture"
                            />
                          </button>
                        </StyledTooltip>
                      </div>
                    )}
                  </div>
                </div>

                {detailed_view && <div style={{ width: '270px', height: '100%', background: '' }} className="rounded-2 versionDetails6 px-2">

                  <h4 className="pt-4">SSE Stream Data</h4>
                  <p>Status: {status}</p>
                  <Button
                    className="rounded-2"
                    color={!recording ? "success" : "danger"}
                    // disabled={evalStatus === "evaluating" ? false : evalStatus === "complete" ? false : true}
                    // onClick={(e) => {
                    //   e.stopPropagation();
                    //   handleStartStop(evalStatus === "complete" ? "start" : "stop");
                    // }}
                    onClick={handleToggleRecording}
                  >
                    {!recording ? "Start" : "Stop"}
                  </Button>
                  <div className="mt-4">
                    <h6>Labels</h6>
                  </div>
                  <div className="mt-4">
                    <h6>Opacity</h6>
                  </div>
                  <div>{JSON.stringify(data)}</div>

                  {/* <div className="mt-3">
                    <Button color="primary" onClick={() => setShowMediaModal(true)}>
                      View Media
                    </Button>
                  </div> */}
                </div>}

              </div>
              {mediaList.length > 0 &&
              <div>
                <div className="d-flex gap-3 overflow-auto">
                          
                          {mediaList.map((item, i) => (
                            <div key={i} style={{ textAlign: "center" }}>
                              {item.type === "video" ? (
                                <video src={item.url} controls width="300"></video>
                              ) : (
                                <img src={item.url} alt="snapshot" width="300" />
                              )}
                              {/* <div className="mt-2">
                                <Button
                                  size="sm"
                                  color="success"
                                  onClick={() => uploadToS3(item.blob, `${item.type}-${Date.now()}`)}
                                >
                                  Upload
                                </Button>
                              </div> */}
                            </div>
                          ))}
                        </div>

              </div>}


              {showMediaModal && (
                <div className="modal fade show" style={{ display: "block" }}>
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Recorded Media</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowMediaModal(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="d-flex flex-wrap gap-3">
                          {mediaList.length === 0 && <p>No media recorded yet.</p>}
                          {mediaList.map((item, i) => (
                            <div key={i} style={{ textAlign: "center" }}>
                              {item.type === "video" ? (
                                <video src={item.url} controls width="300"></video>
                              ) : (
                                <img src={item.url} alt="snapshot" width="300" />
                              )}
                              <div className="mt-2">
                                <Button
                                  size="sm"
                                  color="success"
                                  onClick={() => uploadToS3(item.blob, `${item.type}-${Date.now()}`)}
                                >
                                  Upload
                                </Button>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="modal-footer">
                        <Button color="secondary" onClick={() => setShowMediaModal(false)}>
                          Close
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          </div></div>
    );

    return detailed_view ? createPortal(streamView, document.body) : streamView;
  }
);

export default VideoStreaming;
